<!--
 * @Author: chenkailun
 * @Date: 2025-02-12 16:04:57
 * @LastEditors: chenkailun
 * @LastEditTime: 2025-02-21 11:14:19
 * @Description: 
 * @FilePath: \solarbiolite\src\components\common\FloatingIcon.vue
-->
<!-- FloatingIcon.vue -->
<template>
  <div class="floating-icon" @click="goContactUs">
    <div class="icon-container">
      <img src="@/assets/image/contactUs.png" alt="悬浮图标" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingIcon',
  methods: {
    goContactUs(){
      this.$router.push({
        name: 'contactUs'
      })
    }
  },
}
</script>

<style scoped>
.floating-icon {
  position: fixed;
  /* top: 72%; */
  /* right: 2.5%; */
  bottom: 170px;
  right: 12px;
  z-index: 1000; /* 确保图标在其他内容之上 */
  cursor: pointer;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 43px;
  height: 43px;
  background-color: white; /* 白色背景 */
  border-radius: 50%; /* 圆形 */
  border: 1px solid #e1e0e0;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 可选：添加阴影效果 */
}

.icon-container img {
  width: 70%; /* 图标大小占容器的70% */
  height: 70%;
}
</style>


// WEBPACK FOOTER //
// src/components/common/FloatingIcon.vue